import React from 'react'
import PropTypes from 'prop-types'

const OperatorImg = props => {
  switch (props.operatorKey) {
    case 'Claro':
      return <p className='mx-auto img-operadora op-claro radius cursor' />
    case 'Nextel':
      return <p className='mx-auto img-operadora op-nextel radius cursor' />
    case 'Oi':
      return <p className='mx-auto img-operadora op-oi radius cursor' />
    case 'Tim':
      return <p className='mx-auto img-operadora op-tim radius cursor' />
    case 'Vivo':
      return <p className='mx-auto img-operadora op-vivo radius cursor' />
    case 'Brasil Telecom':
      return <p className='mx-auto img-operadora op-brasil radius cursor' />
    default:
      return ''
  }
}

OperatorImg.propTypes = {
  operatorKey: PropTypes.string
}

export default OperatorImg



// WEBPACK FOOTER //
// ./src/features/CellphoneRecharge/SelectOperator/OperatorImg.js